<template>
    <div class="bng-last-winnings" :class="[quantityType == 'solo' ? 'bng-last-winnings--solo' : '']">
        <div v-if="quantityType != 'solo'" class="head">
            <span class="is-size-5">{{ "components.common.last-winnings.title" | translate }}</span>
        </div>
        <div class="body">
            <ul class="bng-scrollbar" v-if="winnings && winnings.length">
                <li v-for="winning in lastWin"
                    :key="`${winning.date}:${winning.player}:${winning.gameId}:${winning.jackpotName}:${winning.value}`"
                    :class="[winning.jackpotName ? 'jackpot' : '']">
                    <template v-if="winning.jackpotName">
                        <div class="pic">
                            <span class="icon is-medium has-text-warning has-text-weight-bold">JP</span>
                        </div>
                        <div class="info">
                            <span class="has-text-weight-bold">{{ winning.player }}</span>&nbsp;
                            <span>
                                {{ $t('components.common.last-winnings.won jackpot', { 'jackpot': winning.jackpotName }) }}
                            </span>&nbsp;
                            <span class="has-text-weight-semibold has-text-warning">
                                {{ winning.value | currency(winning.currency) }}
                            </span>
                            !
                        </div>
                    </template>
                    <template v-else>
                        <div class="pic">
                            <span class="icon is-medium" :class="[getCategorySettings(winning.gameCategory) ? getCategorySettings(winning.gameCategory).color : 'has-text-warning']">
                                <i :class="[getCategorySettings(winning.gameCategory) ? getCategorySettings(winning.gameCategory).icon : 'far fa-gem']" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="info">
                            <span class="has-text-weight-bold">{{ winning.player }} </span>
                            <span class="has-text-weight-semibold">{{ "components.common.last-winnings.won" | translate }} </span>
                            <span class="has-text-weight-semibold">{{ winning.value | currency(winning.currency) }}</span>
                            {{ "components.common.last-winnings.in" | translate }}
                            <span
                                class="game-link"
                                @click="getGameLink(winning.gameProvider, winning.gameId)"
                            >
                                {{ winning.gameName }}!
                            </span>
                        </div>
                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

export default {
    name: 'last-winnigs',
    props: ['quantityType'],
    computed: {
        winnings() {
            return Vue.state.winnings.get();
        },
        lastWin() {
            if (this.$props.quantityType === 'solo' && this.winnings) {
                return [this.winnings[0]];
            }
            else {
                return this.winnings;
            }
        }
    },
    async mounted() {
        Vue.state.winnings.watch();
    },
    methods: {
        getCategorySettings(categoryName) {
            return Vue.state.games.categorySettings[categoryName];
        },
        getGameLink(gameProvider, gameId) {
            console.log(1);
            if (gameProvider === "bk") {
                Vue.router.push({ name: 'sport-home' });
            }
            else {
                const game = {
                    gameId: gameId,
                    provider: gameProvider
                };
                Vue.router.teleport.game(game);
            }
        }
    },
    beforeDestroy() {
        Vue.state.winnings.stopWatch();
    }
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/last-winnings/last-winnings.vue